
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { DiscordUser } from '../types/simc';
import userService from '../services/users';

export const useDiscordUser = (discordId: string) => {
    const {
        data: user,
        isLoading,
        error,
        refetch
    } = useQuery<DiscordUser>({
        queryKey: ['discordUser', discordId],
        queryFn: () => userService.getUser(discordId),
        enabled: !!discordId,
        staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    });

    return {
        user,
        isLoading,
        error,
        refetch
    }
};
